import React from "react";
import EntryColor from "../container/EntryColor";

const FlatViewQuinella = ({
  charts,
  getOpenBetsChartModal,
  idQuinella,
  showBetsColumnQ,
}) => {
  var tableContent = [],
    headers;

  if (charts) {
    tableContent = charts.map((chart, i) => {
      let selections = chart.Selections.split(",");
      return (
        <tr key={i}>
          <td>
            <EntryColor
              entryNum={parseInt(selections[0])}
              saddleNum={selections[0]}
            />
          </td>
          <td>
            <EntryColor
              entryNum={parseInt(selections[1])}
              saddleNum={selections[1]}
            />
          </td>
          <td style={{ fontWeight: "bold", verticalAlign: "middle" }}>
            ${chart.Amount.toFixed(2)}
          </td>
          {showBetsColumnQ && (
            <td
              style={{ verticalAlign: "middle" }}
              className="cantBets"
              data-toggle="modal"
              data-target="#openBetsChartModal"
              onClick={() =>
                getOpenBetsChartModal(idQuinella, chart.Selections)
              }
            >
              {chart.BetCount}
            </td>
          )}
        </tr>
      );
    });
  }
  let header = 1;
  headers = (
    <React.Fragment key={header++}>
      <tr className="text-center">
        <th>1ST LEG</th>
        <th>2ND LEG</th>
        <th>Money</th>
        {showBetsColumnQ && <th># Bets</th>}
      </tr>
    </React.Fragment>
  );

  return (
    <>
      <table className="table table-striped table-sm mt-2">
        <thead>{headers}</thead>
        <tbody className="table-sm text-center table-bordered">
          {tableContent}
        </tbody>
      </table>
    </>
  );
};

export default FlatViewQuinella;
